import { areContactPersonsActive } from '@newStore/validation/validationRules/contactPersonActive';
import { selectChangeMessageForPersonPicker } from '@UI/aside/asidePersonPicker/asidePersonPickerSelectors';
import type { EditAsideContactsOrCreators } from '@nodeTypeConfig/configTypes';
import { defaultContactsParameters } from '@store/constants/constants';

export const proContactsComponent: EditAsideContactsOrCreators = {
  component: 'contacts',
  property: 'contacts',
  label: 'Contactpersonen',
  reactComponent: 'AsidePersonPicker',
  asideChangeMessageSelector: selectChangeMessageForPersonPicker,
  validations: [areContactPersonsActive],
  options: {
    queryParams: defaultContactsParameters,
  },
};

export const singleContactComponent: EditAsideContactsOrCreators = {
  ...proContactsComponent,
  label: 'Contactpersoon',
  options: {
    ...proContactsComponent.options,
    multiple: false,
  },
};
